import { EAccountPlansType } from "../../Enum/EAccountPlansType"

export class PlanUsageStatus {
  planType: EAccountPlansType

  subscriptionStatus: string

  currentMonthOrders: number

  monthlyOrdersLimit: number

  usagePercent: number

  isLimitReached: boolean

  isNearLimit: boolean

  remainingOrders: number

  cycleStartUtc: Date

  cycleEndUtc: Date

  constructor(data: Partial<PlanUsageStatus>) {
    this.planType = data.planType ?? EAccountPlansType.None

    this.subscriptionStatus = data.subscriptionStatus ?? "pending"

    this.currentMonthOrders = data.currentMonthOrders ?? 0

    this.monthlyOrdersLimit = data.monthlyOrdersLimit ?? 0

    this.usagePercent = data.usagePercent ?? 0

    this.isLimitReached = data.isLimitReached ?? false

    this.isNearLimit = data.isNearLimit ?? false

    this.remainingOrders = data.remainingOrders ?? 0

    this.cycleStartUtc = data.cycleStartUtc ? new Date(data.cycleStartUtc) : new Date()

    this.cycleEndUtc = data.cycleEndUtc ? new Date(data.cycleEndUtc) : new Date()
  }
}
